import { useEffect, useState } from "react";
import { Column } from "../../../../ts/types";
import { getScreeningQuestions } from "../../../../services/masters";
import Modal, {
  ModalBody,
  ModalFooter,
} from "../../../../components/Modal/Modal";
import ScreeningQuestion from "../../../../ts/models/ScreeningQuestion";
import DragDropTable from "../../../../components/CustTable/DragDropTable";
import PrimaryButton from "../../../../components/Buttons/PrimaryButton";
import classes from "./ScreeningQuestionsOrdering.module.css";

type Props = {
  items: ScreeningQuestion[];
  onClose: () => void;
  setItemsHandler: (items: Set<string>) => void;
};

const ScreeningQuestionsOrdering: React.FC<Props> = ({
  items,
  onClose,
  setItemsHandler,
}) => {
  const [tableData, setTableData] = useState(items);
  const [selectedScreeningQuestions, setSelectedScreeningQuestions] = useState<
    ScreeningQuestion[]
  >([]);

  useEffect(() => {
    const fetchScreeningQuestionsFromIds = async () => {
      const logicQuestions = items.filter((data) => data.logicQuestion);
      const screeningQuestionIds = logicQuestions.map(
        (screeningQues) => screeningQues.logicQuestion
      );

      if (screeningQuestionIds?.length) {
        try {
          const screeningQuestionRes = await getScreeningQuestions(
            screeningQuestionIds
          );
          if (screeningQuestionRes.status) {
            setSelectedScreeningQuestions(screeningQuestionRes.data);
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        setSelectedScreeningQuestions([]);
      }
    };

    fetchScreeningQuestionsFromIds();
  }, []);

  const getQuestionById = (questionId?: string) => {
    return selectedScreeningQuestions.find(
      (question) => question.id === questionId
    );
  };

  const columns: Column<ScreeningQuestion>[] = [
    {
      header: "ID",
      accessor: (e, idx) => idx + 1,
      width: "8%",
    },
    {
      header: "QUESTION",
      accessor: (e) => e.question,
      width: "40%",
    },
    {
      header: "SHOWN WHEN",
      accessor: (e) => getQuestionById(e?.logicQuestion)?.question || "",
      width: "40%",
    },
    {
      header: "RESPONSE IS",
      accessor: (e) => e.logicQuestionResponse || "",
      width: "12%",
    },
  ];

  const itemsHandler = () => {
    const itemIdsSet = new Set(
      tableData.map((screeningQuestion) => screeningQuestion.id)
    );
    setItemsHandler(itemIdsSet);
    onClose();
  };

  return (
    <Modal title={<>Change Screening Questions Ordering</>} onClose={onClose}>
      <>
        <ModalBody>
          <>
            <div className={classes.main}>
              <DragDropTable
                columns={columns}
                data={tableData}
                setUpdateData={(screeningQuestions: ScreeningQuestion[]) =>
                  setTableData(screeningQuestions)
                }
              />
            </div>
            <div className={classes.information}>
              Drag and drop to change the question order.
            </div>
          </>
        </ModalBody>
        <ModalFooter>
          <div className={classes.actions}>
            <PrimaryButton name='OK' onClick={itemsHandler} />
            <PrimaryButton
              className={classes.actionBtn}
              name='Cancel'
              onClick={onClose}
              transparent
            />
          </div>
        </ModalFooter>
      </>
    </Modal>
  );
};

export default ScreeningQuestionsOrdering;
